if (!customElements.get('home-review-carousel')) {
  class HomeReviewCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.track = this.querySelector('[data-review-track]');
      this.previousButton = this.querySelector('[data-review-prev]');
      this.nextButton = this.querySelector('[data-review-next]');
      this.navigation = this.querySelector('[data-review-navigation]');
      this.status = this.querySelector('[data-review-status]');

      if (!this.track || !this.previousButton || !this.nextButton) return;

      this.initialized = true;
      this.handleScroll = this.update.bind(this);
      this.handlePrevious = () => this.move(-1);
      this.handleNext = () => this.move(1);

      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      this.previousButton.addEventListener('click', this.handlePrevious);
      this.nextButton.addEventListener('click', this.handleNext);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.handleScroll);
        this.resizeObserver.observe(this.track);
      }

      requestAnimationFrame(() => this.update());
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.track.removeEventListener('scroll', this.handleScroll);
      this.previousButton.removeEventListener('click', this.handlePrevious);
      this.nextButton.removeEventListener('click', this.handleNext);

      if (this.resizeObserver) this.resizeObserver.disconnect();
      this.initialized = false;
    }

    getCardsPerPage() {
      return window.matchMedia('(min-width: 990px)').matches ? 3 : 1;
    }

    move(direction) {
      const card = this.track.querySelector('[data-review-card]');
      if (!card) return;

      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const distance = (card.getBoundingClientRect().width + gap) * this.getCardsPerPage();

      this.track.scrollBy({
        left: direction * distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    update() {
      const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const currentScroll = Math.abs(this.track.scrollLeft);
      const hasOverflow = maximumScroll > 2;

      this.navigation.hidden = !hasOverflow;
      this.previousButton.disabled = !hasOverflow || currentScroll <= 2;
      this.nextButton.disabled = !hasOverflow || currentScroll >= maximumScroll - 2;

      if (this.status) {
        const cards = this.track.querySelectorAll('[data-review-card]');
        const firstCard = cards[0];
        if (!firstCard || !cards.length) return;

        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const cardWidth = firstCard.getBoundingClientRect().width + gap;
        const firstVisible = Math.min(cards.length, Math.round(currentScroll / cardWidth) + 1);
        const lastVisible = Math.min(cards.length, firstVisible + this.getCardsPerPage() - 1);
        this.status.textContent = 'Showing reviews ' + firstVisible + ' to ' + lastVisible + ' of ' + cards.length;
      }
    }
  }

  customElements.define('home-review-carousel', HomeReviewCarousel);
}
